import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((error) => {
      // TODO: handle 401 (logout + redirect), 403, 500, toast notifications
      return throwError(() => error);
    })
  );
};
